export default {
  setFeatureSwitchesState(state, switches) {
    state.switches = switches;
  },
  setFeatureSwitchesLoadedState(state, loaded) {
    state.loaded = loaded;
  },
};
